package io.github.jangalinski.pages._2016._03._25

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initMatchingCollectorPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("2016/03/25/MatchingCollector.md", FrontMatterElement.Builder { addScalar("title", "Java8-Stream Collect BestMatch for given condition"); addScalar("date", "2016-03-25"); }))
}

@Page("/2016/03/25/matching-collector")
@Layout(".site.components.layout.BlogLayout")
@Composable
fun MatchingCollectorPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I just started a ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/jangalinski/snippets") {
            org.jetbrains.compose.web.dom.Text("snippets-repository")
        }
        org.jetbrains.compose.web.dom.Text(" to collect and discuss some useful helpers or spikes I came along.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Today, let's start with the ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/jangalinski/snippets/blob/master/src/main/java/io/github/jangalinski/stream/MatchingCollector.java") {
            org.jetbrains.compose.web.dom.Text("MatchingCollector")
        }
        org.jetbrains.compose.web.dom.Text(", which is used as a collector to terminate a stream. I believe, it is quite useful to replace a ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("filter(...).sorted(...).findFirst()")
        }
        org.jetbrains.compose.web.dom.Text(" chain.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This simple example shows how to use the Collector to find the highest number in a stream (like Collectors.max() would do).")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""Stream.of(1, 45, 3, 2, null, 10,7,19,4,7,39).parallel().collect(match((a, b) -> b > a))); // = Optional.of(45)
""") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This will internally store the first value of the stream and then apply the given biPredicate to each following stream item, comparing the old and the new value. 45 will match because it is greater than 1, and none of the follow up items are greater, so this is the final result. As you can see, this can be used in parallel.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("let-us-have-a-look-at-the-implementation") }) {
        org.jetbrains.compose.web.dom.Text("Let us have a look at the implementation:")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The embedded gist from the original post is still available here: ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://gist.github.com/2471f822440aaf2f9c58") {
            org.jetbrains.compose.web.dom.Text("2471f822440aaf2f9c58")
        }
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The collector is created by passing a BiPredicate that defines under which condidition the new element is a better match than the previous stored result.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The collector stores the result value internally in a AtomicReference, that is initially created via the supplier(). The supplier is called when the stream is created (can be multiple when used parallelly).")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("for each processed stream element, the BiConsumer provided by accumulator() is used. This evaluates the predicate to determine if the stream item will become the new container value.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("When using parallel streams, the streams are merged by the function provided by the combiner(). In this case, the internal value is compared using the test() method and the better matching result is kept.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("On finish, we wrap the internal reference value with in Optional (as it might still be null if no element matched the predicate).")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("the test() implements the BiPredicate and makes sure that null values are treated correctly even when the predicate given by the user does not deal with null.")
        }
    }
}
